import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001/api';

const ProjectCategorySelect = ({ category, onChange }) => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${API}/projects/categories`);
      setCategories(response.data.categories || []);
    } catch (error) {
      console.error('Failed to fetch categories:', error);
    }
  };

  return (
    <select
      value={category || ''}
      onChange={(e) => onChange(e.target.value || null)}
      className="w-full px-3 py-2.5 border-2 border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 dark:focus:ring-cyan-400 focus:border-cyan-500 dark:focus:border-cyan-400 transition-colors font-medium"
    >
      <option value="" className="text-gray-500 dark:text-gray-400">No category</option>
      {categories.map(cat => (
        <option key={cat} value={cat} className="text-gray-900 dark:text-gray-100">{cat}</option>
      ))}
    </select>
  );
};

export default ProjectCategorySelect;
